// GET /api/v1/zdravi — stav serveru a verze nasazení (docs/09-technologie.md §3).
import type { Zdravi } from '@ecoser/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from './klient';

// Tvar odpovědi je dán kontraktem (schéma `Zdravi` v api/openapi.yaml → @ecoser/shared).
export type { Zdravi };

export const KLIC_ZDRAVI = ['zdravi'] as const;

export function useZdravi() {
  return useQuery({
    queryKey: KLIC_ZDRAVI,
    queryFn: ({ signal }) => api.get<Zdravi>('/zdravi', { signal }),
    refetchInterval: 30_000,
    retry: 1,
  });
}
